import { z } from 'zod';
import { fromPrismaDate, isStorableCalendarDate, parseCalendarDate, toPrismaDate, } from '../../dates/index.js';
function calendarDateOrNull(value) {
    try {
        return value instanceof Date ? fromPrismaDate(value) : parseCalendarDate(value);
    }
    catch {
        return null;
    }
}
/** UTC midnight of a `YYYY-MM-DD` or a UTC-midnight `Date`; any other value adds `message`. */
function toUtcMidnightOrIssue(value, context, { message, earliest, earliestMessage }) {
    const ymd = calendarDateOrNull(value);
    if (!isStorableCalendarDate(ymd)) {
        context.addIssue({ code: 'custom', message });
        return z.NEVER;
    }
    if (earliest !== undefined && ymd < earliest) {
        context.addIssue({ code: 'custom', message: earliestMessage ?? message });
        return z.NEVER;
    }
    return toPrismaDate(ymd);
}
/**
 * A `@db.Date` (LocalDate) field: a form's `YYYY-MM-DD`, or the UTC-midnight `Date` the API's
 * LocalDate scalar parses; out as that UTC-midnight `Date`, the shape Prisma writes. An instant
 * (`…T07:00:00Z`, or a `Date` off midnight) is refused, never truncated to its UTC day.
 */
export function localDateInput(message, { earliest, earliestMessage } = {}) {
    return z
        .union([z.string(), z.date()], { error: message })
        .transform((value, context) => toUtcMidnightOrIssue(value, context, { message, earliest, earliestMessage }));
}
/**
 * As {@link localDateInput}; `undefined` leaves the field unchanged and `null` clears it. A form's
 * empty `''` also clears, but over GraphQL only `null` does: the LocalDate scalar refuses `''`
 * before this schema runs.
 */
export function optionalNullableLocalDateInput(message) {
    return z
        .union([z.string(), z.date(), z.null()], { error: message })
        .optional()
        .transform((value, context) => {
        if (value === undefined)
            return undefined;
        if (value === null || value === '')
            return null;
        return toUtcMidnightOrIssue(value, context, { message });
    });
}
//# sourceMappingURL=local-date-input.js.map